/** Use a longer delimiter than the content and preserve edge backticks/spaces. */
export function serializeInlineCode(text: string): string {
  if (!text) return '';
  const fence = '`'.repeat(
    Math.max(
      1,
      ...[...text.matchAll(/`+/g)].map((match) => match[0].length + 1)
    )
  );
  const pad =
    /^`|`$/.test(text) || (/^ .* $/.test(text) && /\S/.test(text)) ? ' ' : '';
  return `${fence}${pad}${text}${pad}${fence}`;
}
